import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Your voting information',
  availableVotingPower: 'Available voting power',
  invalidVoteBalance: 'You don’t have enough {symbol} available to vote',

  yes: 'YAE',
  no: 'NAY',

  amount: 'Amount',
  youVoted: 'You voted',

  notParticipate: 'You did not participate in this proposal',

  noWalletTitle: 'Please connect a wallet to vote',
});
